<RepairDetail headerTextCD ="Central Delivery  Repair/Event" detailsType="Central Delivery" ListURL="Concentrates/Repairs/RepairDetailSearch">
